// Retry Sendbird Batch Message
export const RETRY_SENDBIRD_BATCH_MESSAGE_REQUEST = 'RETRY_SENDBIRD_BATCH_MESSAGE_REQUEST';
export const RETRY_SENDBIRD_BATCH_MESSAGE_DONE = 'RETRY_SENDBIRD_BATCH_MESSAGE_DONE';
export const RETRY_SENDBIRD_BATCH_MESSAGE_FAILED = 'RETRY_SENDBIRD_BATCH_MESSAGE_FAILED';
export const RETRY_SENDBIRD_BATCH_MESSAGE_RESET = 'RETRY_SENDBIRD_BATCH_MESSAGE_RESET';